// M13.4 — currency formatter shared by CurrencyValue + non-React
// callers (PDF SVG builder, XLSX cell labels, etc).
//
// Lives in a `.ts` (not `.tsx`) so React Refresh's "components only"
// rule on the CurrencyValue render component doesn't trip on a sibling
// non-component export.

/** Format a numeric amount using `Intl.NumberFormat` with the property's
 *  resolved currency code. Falls back to a locale-formatted plain
 *  number when `currencyCode` is null/missing/malformed — keeps the
 *  ecommerce surfaces rendering when the GA4 Admin API was unreachable. */
export function formatCurrencyOrNumber(
  value: number,
  currencyCode: string | null | undefined,
  compact?: boolean,
): string {
  if (!Number.isFinite(value)) return "—";
  if (currencyCode && /^[A-Z]{3}$/.test(currencyCode)) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        notation: compact ? "compact" : "standard",
        maximumFractionDigits: compact ? 1 : 0,
      }).format(value);
    } catch {
      // Unknown ISO 4217 code — fall through to plain number formatting.
    }
  }
  return new Intl.NumberFormat(undefined, {
    notation: compact ? "compact" : "standard",
    maximumFractionDigits: compact ? 1 : 0,
  }).format(value);
}
